<template>
  <div>
  <div class="container">
    <header>
      <app-bar></app-bar>
      
    </header>

    <main>
      <slot></slot>
    </main>

    <footer class="">
    </footer>
  </div>
  </div>
</template>

<script>
import 'bootstrap';
import AppBar from '@/AppBar.vue';

export default {
  components: {AppBar},
  props: {
  }
};
</script>


<style lang="scss" type="text/scss">
@import '../../sass/main.scss';
</style>



// WEBPACK FOOTER //
// src/lib/ui/Layout.vue